import PropTypes from 'prop-types';

import qualityUpdate from './quality-update';

export default PropTypes.shape({
  difficultyMessages: PropTypes.arrayOf(qualityUpdate).isRequired,
  headlineMessages: PropTypes.arrayOf(qualityUpdate).isRequired,
  standardMessages: PropTypes.arrayOf(qualityUpdate).isRequired,
  fateMessage: qualityUpdate,
  actionMessage: qualityUpdate,
  areaMessage: qualityUpdate,
});